// 2020-06-27export { CorralTropaComponent } from './corral-tropa.component';